module.exports = __webpack_public_path__ + "img/powerAmplifier150w.ac1850a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/powerAmplifier150w.png
// module id = xDTu
// module chunks = 0